import "packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/byok/index.css.ts.vanilla.css!=!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/byok/index.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA8VX3W7jKhC-71MgVUdqpVJhx0lT9-68CTbYZtcGFnDi7Oq8-5EhJthxmnVS7V5ESfiZmW9-vhle2S5p9A8Efj0AQJiWNT6koKhp9_EA7DckTNHcMMFTkIu6bXi_U2KZgjiR3cfDfw-vTkhkhWRCEapSEMkOaFEzAnZYPUGIi4JxCncxrPGBKsi4ZoT-a09Dd-n5w9-HChPW6hRspbVE7KgqarFPQcUIodaGDOffSyVaTtILOk4noFSswerwHNgbz4PGNSs5ZIY2OgU55Yaqfvlbqw0rDjAX3FBuUqAlzinMqNlTevJJFDuDJSaE8dItgGjjVrMBrjGiudVHHsDKAigEN1Czn3TiBbfeWKfa33vKysqkYINQv5aLWqhzzxnamTlvJdeVddoqq_uF6qgsRg75Z9o0zQUnE33rpSl5IW42KskkKPFWdt40a4O9fbrnzdgsM8PfexvfKxUj1hrFCDS0kTU2FLpb2lUSiAoFcGvENTB_MsXe0hprA_OK1SQoby8eBWe39sAFhKvYIQzOv9vzQuKcmUMK0GuyXVzWs6mD7yvs09aeEVMNPAeAz-lk5OqBqjbLMv0rkGYW6QWNWWuM4EEtjzU-Fqh4K4pAWm6lHUEP-TSAdv_9WTIN3nr9NZDoZ5BmnJi3SvdHS4Wzq9VcWOEN4_CI0jLh0r43bnvlomyzAo5NbWrHH2LyyoVupqPaG6cNWtdMaqZtKVTMUGh7Xgq42Cssr5p87AeLqZ99wrm94hQM6q03x4n5LaSpoTTf39-nHUB2QxgCDFHklkYtLPoLhf09rILHLIlX0Rk5PhZFsS7Wwa36xlT0Apo5521n2s3HV0x6d3uJ3zS2DvE85cI8nx9x32zmvR7yMMVtMONRaOVNQiadb0WbQOSP3x4JF1OAsqK92mPGDa0JoX-ce7tesY2hn0s-i-SdCesTBoEInXHHRcoez8PxDVkVtvDfI3sARGt6xT1Zcxp6Nk1ljXNaiZpQdbXZBmdH8UkLkbc6pIsFU0gftwqTvscg2flPz8mqzPDTCr2AaI1eQLxavwD0ukKhbn3feGcznnJy1o2xKhmHRpyxonFTg9tXLo7DoH49-72YdpbT_fZutB1ttngdbu8XPSgUlRQb68iG8QZ3T4nsXvoB_Pn5zFmhMyYFHyVoyv6b42Nj-vzv_Gzlc32WVvunTv9BbugZdbR1tiW0H0n_By2K7T-YEAAA\"}!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var bar = 'iv4msqx';
export var capabilityIcon = 'iv4msqa';
export var capabilityIconActive = 'iv4msqb';
export var capabilityIconSvg = 'iv4msqc';
export var capabilityRow = 'iv4msq8';
export var capabilityRowInactive = 'iv4msq9';
export var chart = 'iv4msqw';
export var dangerTag = 'iv4msqk';
export var description = 'iv4msq4';
export var dragHandle = 'iv4msqe';
export var empty = 'iv4msq5';
export var error = 'iv4msqu';
export var field = 'iv4msqp';
export var form = 'iv4msqo';
export var input = 'iv4msqr';
export var label = 'iv4msqq';
export var locked = 'iv4msqn';
export var modalActions = 'iv4msqs';
export var notice = 'iv4msqm';
export var panel = 'iv4msq1';
export var panelHeader = 'iv4msq2';
export var row = 'iv4msq7';
export var rowActions = 'iv4msql';
export var rowDescription = 'iv4msqh';
export var rowDisabled = 'iv4msqd';
export var rowMain = 'iv4msqf';
export var rowTitle = 'iv4msqg';
export var rows = 'iv4msq6';
export var stack = 'iv4msq0';
export var success = 'iv4msqv';
export var tag = 'iv4msqj';
export var tags = 'iv4msqi';
export var testStatus = 'iv4msqt';
export var title = 'iv4msq3';